import React, { useState } from 'react';
import '../css/freeclaimdetailspage.css';

const FreeClaimDetailsPage = () => {
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);

  return (
    <div className="freeclaim-container">
      <div className="freeclaim-info">
        <h2 className="freeclaim-heading">
          <span style={{ color: "#192437" }}>Get Help with </span>
          <span style={{ color: "#F5A526" }}>FREE Claim Consultancy</span>
        </h2>
        <p className="freeclaim-text">
          Insurance claims can be stressful and confusing. That’s where we come in. Our <strong>FREE Claim Consultancy</strong> is here to guide you every step of the way.
          From understanding the documentation to handling insurer queries, we simplify the entire process.
        </p>

        <h2 className="freeclaim-subheading">
          <span style={{ color: "#192437" }}>Why </span>
          <span style={{ color: "#F5A526" }}>Choose Our Help?</span>
        </h2>
        <ul className="freeclaim-benefits">
          <li className="freeclaimpoints"><strong>Expert Guidance:</strong> Get claim support from experienced professionals who understand the insurance ecosystem.</li>
          <li className="freeclaimpoints"><strong>Faster Approvals:</strong> Ensure documents are correct and complete to avoid unnecessary delays or rejections.</li>
          <li className="freeclaimpoints"><strong>100% Free:</strong> We do not charge for helping you understand and process your insurance claims.</li>
          <li className="freeclaimpoints"><strong>End-to-End Support:</strong> From claim intimation to settlement, we’ve got your back.</li>
        </ul>

        <p className="freeclaim-text spaced-text">
          Don’t let confusion delay your claim. <strong>Get FREE support</strong> today by filling out the form below.
        </p>
      </div>
      <div className="freeclaim-form-div">
        <h4 className="freeclaim-form-heading">
          <span style={{ color: "#FFF" }}>Start Your </span>
          <span style={{ color: "#F5A526" }}>FREE Claim Consultancy</span>
        </h4>

        <form onSubmit={(e) => { e.preventDefault(); setIsFormSubmitted(true); }}>
          <div className="bottom-form-row">
            <div>
              <label>Full Name</label>
              <input type="text" placeholder="Enter your name" required />
            </div>
            <div>
              <label>Email ID</label>
              <input type="email" placeholder="Enter your email" required />
            </div>
          </div>

          <div className="bottom-form-row">
            <div>
              <label>Mobile No</label>
              <input type="tel" placeholder="Enter your mobile number" required />
            </div>
            <div>
              <label>Policy Type</label>
              <input type="text" placeholder="e.g. Health, Life, Car" required />
            </div>
          </div>

          <div className="bottom-form-row">
            <div>
              <label>Claim Issue Description</label>
              <input type="text" placeholder="Brief your claim issue" required />
            </div>
            <div>
              <label>Upload Claim Documents</label>
              <input type="file" accept=".pdf,.jpg,.jpeg,.png,.doc,.docx" required />
            </div>
          </div>

          <button type="submit" className="freeclaim-submit-btn">Submit</button>
        </form>
      </div>
    </div>
  );
};

export default FreeClaimDetailsPage;
